import { gql } from "urql";
export const AcceptTermsConditionsMutation = gql `
    mutation AcceptTermsConditions {
        users {
            acceptTermsConditions
        }
    }
`;
export const ResetPasswordMutation = gql `
    mutation ResetPassword(
        $userIdToReset: String!
        $temporaryPassword: String!
    ) {
        users {
            resetPassword(
                userIdToReset: $userIdToReset
                temporaryPassword: $temporaryPassword
            ) {
                success
            }
        }
    }
`;
export const ActivateUserMutation = gql `
    mutation ActivateUser($userId: String!) {
        users {
            activateUser(userId: $userId) {
                userId
                isActive
            }
        }
    }
`;
export const DeactivateUserMutation = gql `
    mutation DeactivateUser($userId: String!) {
        users {
            deactivateUser(userId: $userId) {
                userId
                isActive
            }
        }
    }
`;
export const DeleteUserMutation = gql `
    mutation DeleteUser($userId: String!) {
        users {
            deleteUser(userId: $userId) {
                userId
            }
        }
    }
`;
export const CreateUserMutation = gql `
    mutation CreateUser($input: UserCreateInput!) {
        users {
            createUser(input: $input) {
                userId
                firstName
                lastName
                email
                phoneNumber
                isActive
                roleName
            }
        }
    }
`;
export const UpdateUserMutation = gql `
    mutation UpdateUser($input: UserUpdateInput!) {
        users {
            updateUser(input: $input) {
                userId
                firstName
                lastName
                email
                phoneNumber
                imageUrl
                isActive
                roleName
                daysAvailable
                about
                notes
                educationAndCertifications
                preferredAges
                locations {
                    locationId
                    name
                }
                therapyCategory {
                    therapyCategoryId
                    name
                }
                therapySubCategories {
                    therapySubCategoryId
                    name
                }
            }
        }
    }
`;
export const Masquerade = gql `
    mutation Masquerade($organizationId: String) {
        users {
            masquerade(organizationId: $organizationId) {
                success
            }
        }
    }
`;
export const ExportDataMutation = gql `
    mutation ExportData(
        $exportOrganizations: Boolean
        $exportOrganizationAdmins: Boolean
        $exportProviders: Boolean
        $exportCaseManagers: Boolean
        $exportCaregivers: Boolean
        $exportLocations: Boolean
        $exportPhoneNumber: Boolean
        $exportEmail: Boolean
    ) {
        data {
            exportData(
                exportOrganizations: $exportOrganizations
                exportOrganizationAdmins: $exportOrganizationAdmins
                exportProviders: $exportProviders
                exportCaseManagers: $exportCaseManagers
                exportCaregivers: $exportCaregivers
                exportLocations: $exportLocations
                exportPhoneNumber: $exportPhoneNumber
                exportEmail: $exportEmail
            ) {
                id
                organizationId
                organizationName
                organizationTypes
                numberOfProviders
                name
                phoneNumber
                email
                active
                termsAndConditions
                address1
                address2
                city
                stateId
                postalCode
            }
        }
    }
`;
